import React from 'react';
import socialMedia from './data/social_media.png';

export const MobileBlog = () => {
  return (
    <div className="mobile-blog">
      <div className="blog-heading">
        <p>Блог</p>
      </div>
      <div className="mobile-blog-content">
        <div className="social-media-image">
          <div className="social-media-buttons-block">
            <div className="instagram-mobile-blog-button mobile-blog-button">
              {/* <a href="#"> */}
                <p>Перейти</p>
                <i className="fab fa-instagram"></i>
              {/* </a> */}
            </div>
            <div className="facebook-mobile-blog-button mobile-blog-button">
              {/* <a href="#"> */}
                <p>Перейти</p>
                <i className="fab fa-facebook-square"></i>
              {/* </a> */}
            </div>
          </div>
          <img src={socialMedia} alt="Social media" />
        </div>
      </div>
    </div>
  );
};
